class Tab {
  constructor() {
    this.init();
  }
  init() {
    if (!document.querySelector('.js-tab')) return;
    this.tab();
  }
  tab() {
    const tabs = document.querySelectorAll('.js-tab-btn');
    const panels = document.querySelectorAll('.js-tab-panel');

    tabs.forEach(tab => {
      tab.addEventListener('click', e => {
        const target = tab;
        tabs.forEach(tab => {
          tab.setAttribute('aria-selected', false);
        });
        target.setAttribute('aria-selected', true);
        panels.forEach(panel => {
          panel.classList.remove('is-show');
        });
        document.getElementById(target.getAttribute('aria-controls')).classList.add('is-show');
      });
    });
  }
}

export default Tab;
